export default "__VITE_ASSET__f53e8fcb__"